import { URL_PATH } from '@/consts'

export const MYCARE_URLS = [URL_PATH.GetStarted, URL_PATH.MyCare]
